import React from 'react';
import type ProjectCleanupDetail from '@atlassian/jira-spa-apps-admin-pages-performance-project-cleanup/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectCleanupDetail = lazyForPaint<typeof ProjectCleanupDetail>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-project-cleanup" */ '@atlassian/jira-spa-apps-admin-pages-performance-project-cleanup'
		),
	),
);

export const ProjectCleanupMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectCleanupDetail}
		pageId="system-performance-metric-detail-project-cleanup"
		shouldShowSpinner
	/>
);
